export default __webpack_public_path__ + "static/media/notion-logo.b15a774d.png";